module.exports = __webpack_public_path__ + "img/oven-icon-black.4264de88.png";